import {InjectionToken} from '@angular/core';

export const BUILD_HASH_TOKEN = new InjectionToken<string>('buildHash');
